<template>
  <div>
    <form @submit.prevent="addBody">
      <div class="space-y-4">
        <div>
          <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Reason Name</label>
          <input
            type="text"
            v-model="form.reason"
            placeholder="eg Uganda Law Society"
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
            required
          />
        </div>
        <div class="flex justify-end">
          <button
            type="submit"
            :disabled="spinner"
            class="btn-primary"
          >
            <i class="fa-solid fa-save"></i>
            <span>Save</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useConfigurationsStore } from "../../../../stores";

interface ReasonForm {
  reason: string | null
  id: string | null
}

interface DraftData {
  reason: string
  id: string
}

interface Props {
  draftData: DraftData
}

const props = defineProps<Props>()

const store = useConfigurationsStore();
const spinner = ref(false)
const form = ref<ReasonForm>({
  reason: null,
  id: null
})

const addBody = () => {
  if (!form.value.reason) {
    return
  }

  spinner.value = true
  store.createReason(form.value);
}

onMounted(() => {
  if (props.draftData) {
    form.value.reason = props.draftData.reason
    form.value.id = props.draftData.id
  }
})

watch(
  () => store.insolvencyReason,
  (reason) => {
    if (reason) {
      spinner.value = false
      store.fetchReasons();
      // @ts-ignore - successToast is injected globally
      window.successToast('Success', 'Request processed successfully')
    }
  }
)

watch(
  () => store.insolvencyError,
  (error) => {
    if (error) {
      spinner.value = false
      // @ts-ignore - errorToast is injected globally
      window.errorToast('Error', 'An error occurred while creating new reason: ' + error.errors[0].message)
    }
  }
)
</script>

